// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"E7-z"};